var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"signularity-top-nav-undo-redo"},[_c('IconButton',{attrs:{"disabled":!_vm.canUndo,"icon":"UndoIconSolid","size":"16"},on:{"click":_vm.undo}}),_c('IconButton',{attrs:{"disabled":!_vm.canRedo,"icon":"RedoIconSolid","size":"16"},on:{"click":_vm.redo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }